import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";
import { LiaLongArrowAltRightSolid } from "react-icons/lia";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  fetchCaptcha,
  submitEDM,
  fetchChannel,
} from "../../redux/actions/edmAction.js";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import i18n from "../../i18n";
import { useHistory } from "react-router-dom";
import EDMHeader from "./EDMHeaderV2";
import EDMFooter from "./EDMFooter";
import EDMBanner from './EDMBanner';

import { useFormik } from "formik";
import DataPrivacyContent from "../DataPrivacyContent";

const useStyles = makeStyles((theme) => ({
  edmStyle: {
    fontFamily: "Montserrat, Noto Sans TC, Noto Sans SC, Arial, Helvetica, sans-serif !important",
  },
  header: {
    width: "100%",
    // backgroundColor: "#243d77",
    // textAlign: "center",
    // color: "white",
    padding: "0 0 15px 0",
    display: "grid",
    // gridTemplateColumns: "50% 50%",
    // [theme.breakpoints.up('md')]: {
    gridTemplateColumns: "40% 60%",
    // },
    justifyContent: "center",
    alignItems: "center",
  },
  bannerContainer: {
    position: "relative",
    backgroundImage: "url(/media/Banner.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
  },
  bannerHeader: {
    fontSize: "2.5vw",
    fontWeight: "bold",
    textAlign: "center",
    color: "rgb(0,55,123)",
    padding: "16px",
    maxWidth: "400px",
    margin: "auto",
  },
  bannerImg: {
    width: "100%",
  },
  bannerVerticalCenter: {
    margin: "0",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    textAlign: "center",
    width: "100%",
    fontSize: "30px",
  },
  body: {
    marginBottom: "50px",
  },
  form: {
    maxWidth: "400px",
    margin: "auto",
    padding: "40px 10px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  formInfo: {
    maxWidth: "400px",
    margin: "auto",
    padding: "10px",
  },
  submitBtnBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    backgroundColor: "#f1f1f1",
    verticalAlign: "middle",
  },
  footer: {
    width: "100%",
    backgroundColor: "#243d77",
    textAlign: "center",
    color: "white",
    position: "fixed",
    bottom: "0",
    padding: "10px 0",
  },
  mandatoryLabel: {
    color: "#f38660",
  },
  submitButton: {
    width: "200px",
    margin: "auto",
    backgroundImage: "linear-gradient(#f7925a, #f15a23)",
    border: "none",
  },
  captchaStyle: {
    width: "100px",
    height: "40px",
  },
  errorMsg: {
    color: "#ff0000",
    fontSize: "12px",
  },
}));

function EDMSubmitV2() {
  const { t } = useTranslation();
  const history = useHistory();
  const { channel } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const captchaB64Str = useSelector((state) => state.captchaB64Str);
  const isPublic = useSelector((state) => state.isPublic);
  const isFutures = useSelector((state) => state.isFutures);
  const [showModal, setShowModal] = useState(false);
  const [modalHeader, setModalHeader] = useState("");
  const [modalContent, setModalContent] = useState("");

  const initialValues = {
    // title: "",
    // firstName: "",
    // familyName: "",
    // mobileCountryCode: "",
    // mobileNumber: "",
    email: "",
    captchaCode: "",
    referenceNo: "",
  };

  const validate = (values) => {
    // set the reference no before submit
    formik.setFieldValue(
      "referenceNo",
      isPublic ? "edm-secpub" : isFutures ? "edm-futprv" : "edm-secprv"
    );

    const errors = {};
    if (!values.email) {
      errors.email = "EDM.Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "EDM.InvalidEmailFormat";
    }
    if (!values.captchaCode) {
      errors.captchaCode = "EDM.Required";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validate,
    onSubmit: (values) => {
      handleEDMSubmit(values);
    },
  });

  useEffect(() => {
    refreshCaptcha();
    refreshChannel();
  }, [dispatch]);

  function refreshCaptcha() {
    dispatch(fetchCaptcha());
  }

  async function refreshChannel() {
    await dispatch(fetchChannel({ channel: channel }));
  }

  async function handleEDMSubmit(values) {
    let isCaptchaPass = await dispatch(submitEDM(values));
    if (isCaptchaPass) {
      history.push("/edm/confirm?l=" + i18n.language.toLowerCase());
    } else {
      formik.setErrors({ captchaCode: t("EDM.InvalidCaptchaCode") });
    }
  }

  function showDataPrivacy() {
    setModalHeader(t("PersonalInformationCollectionStatement"));
    setModalContent(<DataPrivacyContent />);
    setShowModal(true);
  }

  function handleCloseModal() {
    setShowModal(false);
  }

  function getMobileNoErrorMsg(error) {
    if (formik.values.mobileCountryCode === "852") {
      return t(error).replace("{0}", 8);
    } else if (formik.values.mobileCountryCode === "86") {
      return t(error).replace("{0}", 11);
    } else {
      return t(error);
    }
  }

  return (
    <div className={classes.edmStyle}>
      <EDMHeader props={{}} />
      <EDMBanner titleKey="EDMV2.BannerTitle"/>

      <div className={classes.body}>
        <div
          style={{ padding: "10px 30px", maxWidth: "800px", margin: "auto" }}
        >
          <div>
            <p style={{ fontSize: '16px' }}>{t("EDMV2.StayAbreastKGIFutureUpdatePublic")}</p>
          </div>
        </div>
        <Form onSubmit={formik.handleSubmit}>
          {/* <Form onSubmit={(e) => {

                    formik.handleSubmit();
                }}> */}
          <div style={{ backgroundColor: "rgba(240,244,247,255)" }}>
            <div className={classes.form}>
              <Row>
                <Form.Label>{t("EDMV2.Email")}</Form.Label>
                <Col xs={12}>
                  <Form.Control
                    type="text"
                    name="email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  <span className={classes.errorMsg}>
                    {formik.errors.email &&
                      formik.touched.email &&
                      t(formik.errors.email)}
                  </span>
                </Col>
              </Row>
              <Row>
                <Form.Label>{t("EDMV2.PleaseInputVerificationCode")}</Form.Label>
                <Col xs={6}>
                  <Form.Control
                    type="text"
                    name="captchaCode"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.captchaCode}
                  />
                  <span className={classes.errorMsg}>
                    {formik.errors.captchaCode &&
                      formik.touched.captchaCode &&
                      t(formik.errors.captchaCode)}
                  </span>
                </Col>
                <Col xs={3}>
                  <img
                    className={classes.captchaStyle}
                    src={"data:image/png;base64," + captchaB64Str}
                    alt="captcha"
                  />
                </Col>
                <Col xs={2} style={{ margin: "auto" }}>
                  <Button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    onClick={refreshCaptcha}
                  >
                    <FontAwesomeIcon
                      icon={faSyncAlt}
                      style={{ color: "black" }}
                    />
                  </Button>
                </Col>
              </Row>
              {/* <Row className="mt-3">
                            <Form.Label className={classes.mandatoryLabel}>*{t("EDM.MandatoryFieldsAreRequired")}</Form.Label>
                        </Row> */}
            </div>
          </div>

          <div className={classes.formInfo}>
            <Row>
              <Col>
                <Form.Control
                  type="hidden"
                  name="referenceNo"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.referenceNo}
                />
              </Col>
            </Row>
          </div>

          <div
            style={{ padding: "10px 30px", maxWidth: "800px", margin: "auto" }}
            className="mt-3"
          >
            <div style={{ color: "#818181", fontSize: '12px' }}>
              <p>
                {t("EDM.AgreementDesc1")}
                <a href="#/" onClick={showDataPrivacy}>
                  {t("PersonalInformationCollectionStatement")}
                </a>
                {t("EDM.AgreementDesc2")}
              </p>
              <p>{t("EDM.AgreementDesc3")}</p>
              <p>{t("EDM.AgreementDesc4")}</p>
            </div>
          </div>

          <div className={classes.submitBtnBox}>
            {/* <Row className="mb-3">
                            <Button as="input" type="submit" value={t("EDM.AgreeAndSubmit")} className={classes.submitButton} />
                        </Row> */}

            <button
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="daco-primary-btn"
              type="submit"
            >
              {t("EDM.AgreeAndSubmit")}{" "}
              <LiaLongArrowAltRightSolid
                style={{ marginLeft: 16 }}
                fontSize={24}
              />
            </button>
          </div>

          <div
            style={{ padding: "10px 30px", maxWidth: "800px", margin: "auto" }}
            className="mt-3"
          >
            <div style={{ color: "#818181", fontSize: '12px' }}>
              <p >{t("EDM.KGIHKWillNotSoUseYourPeronalData")}</p>
            </div>
          </div>
        </Form>
      </div>

      <div className={classes.footer}>
        <EDMFooter />
      </div>

      <Modal
        size="lg"
        show={showModal}
        onHide={() => handleCloseModal()}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalContent}</Modal.Body>
      </Modal>
    </div>
  );
}

export default EDMSubmitV2;
